/* eslint-disable no-unused-vars */
import _ from "lodash";
import imask from "imask";
import { testRegex, validaCnpj, validaCpf } from "./validation";

export const formataCampoRegionalizacao = (config) => (value) => {
    if (!config || !config.mascara || !value) return value;
    const MASK = imask.createMask({
        mask: config.mascara,
        definitions: { 'A': /[a-zA-Z0-9]/ },
    });
    return MASK.resolve(value);
};

export const validaCampoRegionalizacao = (validacoes, campo) => {
    return validacoes
            .map(validacao => switchValidacoes(campo, validacao.tipo, validacao.regra))
            .filter(validacao => !!validacao);
};

const switchValidacoes = (campo, tipo, regra = null) => {
    switch (tipo) {
        case 'CPF':
            return validateCpfRegionalizacao;
        case 'CNPJ':
            return validateCnpjRegionalizacao;
        case 'REGEX':
            return regexRegionalizacao(new RegExp(regra), campo);
        default:
            return null;
    }
};

const validateCpfRegionalizacao = value => validaCpf(value) ? undefined : "LABELS.VALIDACAO.CAMPO.CPF_INVALIDO";
const validateCnpjRegionalizacao = value => validaCnpj(value) ? undefined : "LABELS.VALIDACAO.CAMPO.CNPJ_INVALIDO";
const regexRegionalizacao = (regexExp, campo) => (value) =>  testRegex(regexExp, desformata(value)) ? undefined : switchMsgInvalido(campo);

const desformata = value => value.replaceAll(/[^A-Za-z0-9]/g, "");

const switchMsgInvalido = campo => {
    switch (campo) {
        case 'cpf':
            return "LABELS.VALIDACAO.CAMPO.CPF_INVALIDO";
        case 'cnpj':
            return "LABELS.VALIDACAO.CAMPO.CNPJ_INVALIDO";
        case 'telefone':
            return "LABELS.VALIDACAO.CAMPO.TELEFONE_INVALIDO";
        case 'cep':
            return "LABELS.VALIDACAO.CAMPO.CEP_INVALIDO";
        default:
            return "LABELS.VALIDACAO.CAMPO.INVALIDO";
    }
};